export default __webpack_public_path__ + "static/media/climbing-photo.72fc4685.jpeg";